import { Link } from "react-router-dom";
import styled from "styled-components";
import colors from "../../../styles/colors";
import fontSizes from "../../../styles/fontSizes";

export const AnalyticsLink = styled(Link)`
  display: flex;
  margin-left: auto;
  margin-right: 0;
  text-decoration: none;
`;

export const ClickableIconContainer = styled.div`
  width: 1em;
  height: 1em;
  margin: 0.2rem;
  padding: 0.3em 1em;
  background-color: ${colors.white};
  border: 0.2rem solid ${colors.buttonBlue};
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 0.8rem;
  font-size: ${fontSizes.regular};
  color: ${colors.buttonBlue};

  :hover {
    opacity: 0.2;
  }
  &.disabled {
    opacity: 0.4;
    background-color: ${colors.grey};
    cursor: default;
    color: ${colors.white};
    border: 0.2rem solid ${colors.grey};
  }
`;
